import styles from "./checkout.module.css";

import { getIDFromCurrentURL } from "PosterEditor/utils/url-parsing";
import {
  useOrderStore,
  Order,
} from "entity-store/orders-store/use-orders-store";
import { useEffect, useState } from "react";
import { OrderDetail } from "BEDROCK/shared-components/orders/order-detail";
import { UIIcon } from "PosterEditor/common-components/ui-icon-drawing/ui-icon";
import { useCheckout } from "./checkout-provider";
import { useProjectStore } from "entity-store/project-store/use-project-store";

interface CheckoutConfirmationProps {}

export const CheckoutConfirmation = (props: CheckoutConfirmationProps) => {
  const { getOrder } = useOrderStore();
  const { refetchProjects } = useProjectStore();
  const [order, setOrder] = useState<Order | undefined>();
  const { clearCheckout } = useCheckout();

  useEffect(() => {
    const id = getIDFromCurrentURL();
    if (id) {
      refetchProjects().then(() => {
        clearCheckout();
        getOrder(id)
          .then((order) => {
            if (!order) {
              console.error("Order not found");
            } else {
              setOrder(order);
              console.log("Order found:", order);
            }
          })
          .catch((error) => {
            console.error("Error fetching order:", error);
          });
      });
    }
  }, []);

  if (!order) {
    return <MissingOrder />;
  }
  return (
    <div className={styles.container}>
      <div className={styles.listContainer}>
        <div className={styles.listHeader}>
          <UIIcon iconName="CHECK" variant="REGULAR" />
          <h1 className={styles.success}>ORDER CONFIRMED</h1>
        </div>
        <div className={styles.orderInfoSection}>
          <div className={styles.orderDate}>
            <h2 className={styles.sectionTitle}>Order Date:</h2>
            <p>
              {new Date(order.created_at).toLocaleDateString("en-US", {
                year: "numeric",
                month: "long",
                day: "numeric",
              })}
            </p>
          </div>
          {order.shippingAddress && (
            <div className={styles.shippingInfo}>
              <h2 className={styles.sectionTitle}>Shipping to:</h2>
              <div className={styles.addressBlock}>
                <p>{order.shippingAddress.line1}</p>
                {order.shippingAddress.line2 && <p>{order.shippingAddress.line2}</p>}
                <p>{order.shippingAddress.city}</p>
                <p>{order.shippingAddress.postcode}</p>
                <p>{order.shippingAddress.country}</p>
              </div>
              <p className={styles.deliveryInfo}>Standard delivery 4-6 business days</p>
            </div>
          )}
        </div>
        <OrderDetail order={order} onClickPay={() => {}} />
        <div className={styles.listFooter}>
          <div className={styles.listFooterTrailingContent}></div>
        </div>
      </div>
    </div>
  );
};

const MissingOrder = () => {
  return (
    <div className={styles.missingOrder}>
      <h2>Order not found</h2>
      <p>Please check your order ID and try again.</p>
    </div>
  );
};
